import { Notification } from '@thanx/uikit/notification'
import { Text } from '@thanx/uikit/text'
import { defaultTheme } from '@thanx/uikit/theme'
import InfoIcon from 'components/InfoIcon'

type Props = {
  text: string
  showIcon?: boolean
}

const InfoBanner = ({ text, showIcon = false }: Props) => {
  return (
    <Notification kind="info" size="full">
      <div className="d-flex p-xs align-items-center">
        {showIcon && (
          <div className="mr-xs">
            <InfoIcon color={defaultTheme.colors.primary} />
          </div>
        )}
        <Text.BodyText4 color="grey70">{text}</Text.BodyText4>
      </div>
    </Notification>
  )
}

export default InfoBanner
